export default "__VITE_ASSET__f1818ae5__"